import Vue from 'vue';
import Router from 'vue-router';
import About from '../components/About.vue';
import Landing from '../components/Landing.vue';
import Services from "../components/Services.vue";
import Pakam from "../components/Pakam.vue";
import Rotes from "../components/Rotes.vue";
import Sanwo from "../components/Sanwo.vue";
import Report from "../components/Report.vue";
import Contact from "../components/Contact.vue"

Vue.use(Router);



export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
    },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
    },
    {
      path: '/pakam',
      name: 'Pakam',
      component: Pakam,
    },
    {
      path: '/rotes',
      name: 'Rotes',
      component: Rotes,
    },
    {
      path: '/sanwo',
      name: 'Sanwo',
      component: Sanwo,
    },
    {
      path: '/report',
      name: 'Report',
      component: Report,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
  ],
});
